import { render } from "./AddPlant.vue?vue&type=template&id=283f3676"
import script from "./AddPlant.vue?vue&type=script&lang=js"
export * from "./AddPlant.vue?vue&type=script&lang=js"

import "./AddPlant.vue?vue&type=style&index=0&id=283f3676&lang=scss"
import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=1&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__